module.exports = __webpack_public_path__ + "static/eis7-a4226356b0ae7bfea89f4e23986d8136.jpg";